import { render, staticRenderFns } from "./LogoGoRal.vue?vue&type=template&id=f3d3d91a"
var script = {}
import style0 from "./LogoGoRal.vue?vue&type=style&index=0&id=f3d3d91a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports